require('./mortgageRequestAppraisalRequestSuccess.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');

// @ commons
const { formatText } = require('core/i18n').i18n;

// @ components
const MortgageRequestAppraisalRequestConfirmationData = require('../mortgageRequestAppraisalRequestConfirmationData/mortgageRequestAppraisalRequestConfirmationData');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');


const MortgageRequestAppraisalRequestSuccess = props => {
    const { immEstates, immPayment, immAccounts, immAppraisalRequest } = props;

    const mainButton = {
        url: '/myprofile/mortgage/panel',
        label: formatText('mortgageRequestAppraisalRequest-appraisalRequestReturnToPanel')
    };
    const title = formatText('mortgageRequestAppraisalRequest-appraisalRequestConfirmationSuccessTitle');
    const successMessage1 = formatText('mortgageRequestAppraisalRequest-appraisalRequestConfirmationSuccessMessage1');

    return (
        <div className="mortgage-request-appraisal-confirmation-container">
            <WizardSuccess mainButton={mainButton} successMessage={title}>
                <MortgageRequestAppraisalRequestConfirmationData
                    immEstates={immEstates}
                    immPayment={immPayment}
                    immAccounts={immAccounts}
                    immAppraisalRequest={immAppraisalRequest}
                />

                <div className="mortgage-request-appraisal-confirmation-container__messages">
                    <p className="mortgage-request-appraisal-confirmation-container__text">{successMessage1}</p>
                </div>
            </WizardSuccess>
        </div>
    )
};

MortgageRequestAppraisalRequestSuccess.propTypes = {
    immEstates: PropTypes.object.isRequired,
    immPayment: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    getAppraisalVisit: PropTypes.func.isRequired,
    immAppraisalRequest: PropTypes.object.isRequired
};

module.exports.constructor = MortgageRequestAppraisalRequestSuccess;

module.exports = connect(
    state => ({
        immAppraisalRequest: state.mortgageRequestAppraisalRequest
    }), null
)(MortgageRequestAppraisalRequestSuccess);